/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'jquery',
	'../../../../widgets/livewidget/nls/StringResources',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (_, $, resources, ReactDOM, React, Toolkit, PropTypes) {

	const { Container, Label, TextInput } = Toolkit;
	class DrillThroughDefinitionTitleInput extends React.Component {

		constructor(props) {
			super(props);
			this.handlers = props.handlers;
			this.state = {
				name: this.props.name
			};
		}

		render() {
			return (
				<Container className='dtTitleInput'>
					<Label id='dtTitleInputLabel' type='caption' label={resources.get('drillthrough_titleLabel')} />
					<TextInput
						id='dtTitleInput'
						value={this.state.name}
						onChange={this._onChange.bind(this)}
					/>
				</Container> );
		}

		_onChange(value){
			this.handlers.onNameChange(value);
			this.setState({ name: value });
		}
	}

	DrillThroughDefinitionTitleInput.propTypes = {
		name: PropTypes.string,
		handlers: PropTypes.object
	};
	return DrillThroughDefinitionTitleInput;
});

